var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"search-field relative"},[_c('Field',_vm._b({model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}},'Field',_vm.$attrs,false)),_c('SearchIcon',{staticClass:"search-icon absolute w-5 h-5 right-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }